import { Controller } from "@hotwired/stimulus"

// Auto-dismisses flash/toast messages after ~2.6s, matching the prototype's
// toast timing (README: "Toast (bottom-center, auto-dismiss ~2.6s)").
export default class extends Controller {
  static values = { delay: { type: Number, default: 2600 } }

  connect() {
    this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.remove()
  }
}
